import { render } from "./ConnectionsTab.vue?vue&type=template&id=481e42d8&scoped=true"
import script from "./ConnectionsTab.vue?vue&type=script&lang=js"
export * from "./ConnectionsTab.vue?vue&type=script&lang=js"

import "./ConnectionsTab.vue?vue&type=style&index=0&id=481e42d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481e42d8"]])

export default __exports__